import { apiClient } from "@salespark/api-client";

export default apiClient({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000,
});
